/* eslint-disable react/prefer-stateless-function */
import * as Sentry from '@sentry/react';
import * as React from 'react';

interface IEmptyProps {
  children?: React.ReactNode;
}

const RELOAD_FLAG = 'u2r:hook-error-reload-attempted';

// "Invalid hook call" / `useContext` of null typically means a stale chunk loaded after a
// deploy ended up bound to a different React copy. A hard reload picks up the fresh bundle.
// Reload at most once per session to avoid loops if the issue is genuinely persistent.
const looksLikeStaleReactInstance = (error: unknown): boolean => {
  if (!error) {
    return false;
  }
  const message = error instanceof Error ? error.message : String(error);
  return (
    /Invalid hook call/i.test(message) || /Cannot read propert(?:y|ies) of null \(reading 'useContext'\)/i.test(message)
  );
};

const handleError = (error: unknown) => {
  if (typeof window === 'undefined') {
    return;
  }
  if (!looksLikeStaleReactInstance(error)) {
    return;
  }
  try {
    if (sessionStorage.getItem(RELOAD_FLAG)) {
      return;
    }
    sessionStorage.setItem(RELOAD_FLAG, '1');
  } catch {
    // sessionStorage may be unavailable (private mode, embedded contexts) — reload anyway.
  }
  window.location.reload();
};

class ErrorBoundary extends React.Component<IEmptyProps> {
  render() {
    return (
      <>
        {/* @ts-ignore */}
        <Sentry.ErrorBoundary fallback="An error has occurred" showDialog onError={handleError}>
          {this.props.children}
        </Sentry.ErrorBoundary>
      </>
    );
  }
}

export default ErrorBoundary;
